import React from 'react';

export default function LoadingSkeleton() {
  return (
    <div className="animate-pulse">
      {/* Header Skeleton */}
      <div className="max-w-7xl mx-auto mb-12">
        <div className="h-10 w-48 bg-[#1E293B] rounded-lg mb-4"></div>
        <div className="h-6 w-32 bg-[#1E293B] rounded-lg"></div>
      </div>

      {/* Stats Grid Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="bg-[#1E293B] p-6 rounded-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="h-4 w-24 bg-[#334155] rounded"></div>
              <div className="h-10 w-10 bg-[#334155] rounded-full"></div>
            </div>
            <div className="h-8 w-16 bg-[#334155] rounded mb-4"></div>
            <div className="h-4 w-32 bg-[#334155] rounded"></div>
          </div>
        ))}
      </div>

      {/* API Key Section Skeleton */}
      <div className="bg-[#1E293B] p-6 rounded-xl mb-8">
        <div className="flex items-center justify-between mb-6">
          <div className="h-6 w-24 bg-[#334155] rounded"></div>
          <div className="h-10 w-32 bg-[#334155] rounded"></div>
        </div>
        <div className="h-12 bg-[#334155] rounded-lg"></div>
      </div>

      {/* Usage Chart Skeleton */}
      <div className="bg-[#1E293B] p-6 rounded-xl mb-8">
        <div className="h-6 w-32 bg-[#334155] rounded mb-6"></div>
        <div className="h-64 flex items-end justify-between">
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              className="w-8 bg-[#334155] rounded-t-lg"
              style={{ height: `${Math.random() * 100}%` }}
            />
          ))}
        </div>
      </div>

      {/* Subscription Section Skeleton */}
      <div className="bg-[#1E293B] p-6 rounded-xl">
        <div className="h-6 w-48 bg-[#334155] rounded mb-6"></div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-64 bg-[#334155] rounded-xl"></div>
          ))}
        </div>
      </div>
    </div>
  );
}
